import React from 'react';

import { useTheme } from 'styled-components';
import PageWrapper from '../../components/PageWrapper';

import { Container } from './styles';
import Form from './Form';
import Button from '../../components/Button';
import Title from '../../components/Title';
import { setPositionOfRowExpanded } from '../../utils/tableUtils';
import FormWrapper from '../../components/FormWrapper';

import { BeneficiaryIncludeTable } from './BeneficiaryIncludeTable';
import { useBeneficiaryIncludeController } from './controller';
import { IncludeDependentsContainer } from '../ConsultInclusionOfBeneficiaries/styles';
import DepentendInclude from '../Beneficiaries/DepentendInclude';

const BeneficiaryInclude: React.FC = () => {
  const {
    dataTable,
    dependentParams,
    getDataToTable,
    handleSubmitEditRequest,
    handleSubmitNewRequest,
    rowExpanded,
    setRowExpanded,
    setShowDependentIncludeButton,
    setShowForm,
    showDependentIncludeButton,
    showForm,
    templateRowExpanded,
    theme,
    contract,
    requestId,
    setRequestIdForEdit,
    step,
    setStep,
    beneficiary,
    setSelectedRow,
    goBackToShowTable,
  } = useBeneficiaryIncludeController();
  const { colors } = useTheme();

  const defaultColor = colors.palet.institutional3;

  return (
    <>
      {step === 1 && (
        <PageWrapper
          gridTemplateColumns="1fr 8fr 1fr"
          gridTemplateRows="auto 1fr"
        >
          <Container>
            <Title themeColor={theme.colors.palet.institutional8}>
              Inclusão de Beneficiário
            </Title>
            {!showForm.editMode && !showForm.newMode && (
              <>
                <BeneficiaryIncludeTable
                  dataTable={dataTable}
                  templateRowExpanded={templateRowExpanded}
                  rowExpanded={rowExpanded}
                  setRowExpanded={setRowExpanded}
                  setPositionOfRowExpanded={setPositionOfRowExpanded}
                  onRowExpand={setSelectedRow}
                />
                <FormWrapper
                  formLook
                  onSubmit={() =>
                    setShowForm({
                      contractId: contract.contractId,
                      editMode: false,
                      newMode: true,
                      isOwner: true,
                    })
                  }
                  className="actions-include-beneficiary"
                >
                  <Button type="submit" grayButton autoWidth formLook>
                    Novo
                  </Button>
                </FormWrapper>
              </>
            )}
            {showForm.newMode && (
              <Form
                callbackSubmit={
                  !requestId ? handleSubmitNewRequest : handleSubmitEditRequest
                }
                contractId={showForm.contractId}
                isOwner
                showForm={showForm}
                callbackButtonGoBack={() => {
                  goBackToShowTable();
                }}
                showDependentIncludeButton={showDependentIncludeButton}
                dependentParams={dependentParams}
                requestHolderId={requestId}
              />
            )}
            {showForm.editMode && (
              <Form
                callbackSubmit={handleSubmitEditRequest}
                contractId={showForm.contractId}
                // showReleaseButton={requestId}
                showDependentIncludeButton={showForm.isOwner}
                isOwner={showForm.isOwner}
                preloadOfRequestId={requestId}
                showForm={showForm}
                callbackButtonGoBack={() => {
                  goBackToShowTable();
                }}
                requestHolderId={requestId}
                dependentParams={dependentParams}
              />
            )}
          </Container>
        </PageWrapper>
      )}

      {step === 2 && (
        <PageWrapper
          gridTemplateColumns="1fr 8fr 1fr"
          gridTemplateRows="auto 1fr"
        >
          <IncludeDependentsContainer>
            <Title themeColor={defaultColor}>Incluir Dependente</Title>

            <DepentendInclude
              defaultColor={defaultColor}
              callbackSetStep={async () => {
                setShowForm({
                  contractId: '',
                  editMode: false,
                  newMode: false,
                  isOwner: false,
                });
                setShowDependentIncludeButton(false);
                setRequestIdForEdit('');
                setStep(1);
                await getDataToTable(contract.contractId);
              }}
              rowsSelecteds={beneficiary}
              showTitle
            />
          </IncludeDependentsContainer>
        </PageWrapper>
      )}
    </>
  );
};

export default BeneficiaryInclude;
